import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetPaymentAccountsService } from "@/features/accounts/payment/scraping/services/get-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useGetPaymentAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getPaymentAccountsService = new GetPaymentAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 口座一覧取得
  const getPaymentAccounts = async (
    accountGroupId: string,
    paymentAccountId?: string,
    industryCode?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getPaymentAccountsService.getPaymentAccounts({
        account_group_id: accountGroupId,
        ...(paymentAccountId && { payment_account_id: paymentAccountId }),
        ...(industryCode && { industry_code: industryCode }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getPaymentAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getPaymentAccounts: errorHandledAsync(getPaymentAccounts, setError),
  };
};
